import { Command } from 'commander';
import api from '../services/api';
import asyncErrorWrapper from '../utils/async-error-wrapper';
import output from '../utils/output-writer';

const listPlaybooks = new Command('list-playbooks')
  .description(
    'List all available playbooks, including their monitor names and required attributes. Currently only returns playbooks visible to all users.'
  )
  .action(
    asyncErrorWrapper(async () => {
      const result = await api.listPlaybooks();
      output.info(JSON.stringify(result, null, 2));
    })
  );

export default listPlaybooks;
